export default __webpack_public_path__ + "static/media/person.9eaa6d6c.jpg";